import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import React, { Component, useEffect, useState } from 'react'
import { Modal, Grid } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { LocalForm, Control } from 'react-redux-form'
import Errors from '../../components/common/errors'
import { Row, Col, Button, FormGroup, Input, Label } from 'reactstrap'
import {
    facebookContent,
    twitter,
    twitterContent,
    facebook,
    instagram,
    instagramContent
} from '../../utilities/message'
import Loader from '../../components/Loader'
import { useDispatch, useSelector } from 'react-redux';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { editSocialMedia, getSocialMedia } from '../../actions/settings';
import { Textarea } from '@mui/joy';

const SocialMedia = () => {
    const loaders = useSelector((state) => state.loader)
    const socialMediaData = useSelector((state) => state.socialMedia);
    const [facebook, setFacebook] = useState(socialMediaData?.socialMedia?.facebook_post_template);
    const [twitter, setTwitter] = useState(socialMediaData?.socialMedia?.twitter_post_template);
    const [instagram, setInstagram] = useState(socialMediaData?.socialMedia?.instagram_post_template);

    const dispatch = new useDispatch();
    useEffect(() => {
        dispatch(getSocialMedia(null, (res) => {
            setFacebook(socialMediaData?.socialMedia?.facebook_post_template)
            setTwitter(socialMediaData?.socialMedia?.twitter_post_template)
            setInstagram(socialMediaData?.socialMedia?.instagram_post_template)
        }))
    }, [])

    const handleAddSubmit = () => {
        const data = { facebook_post_template: facebook ? facebook : socialMediaData?.socialMedia?.facebook_post_template, twitter_post_template: twitter ? twitter : socialMediaData?.socialMedia?.twitter_post_template, instagram_post_template: instagram ? instagram : socialMediaData?.socialMedia?.instagram_post_template }

        dispatch(
            editSocialMedia(data, (res) => {
                if (res) {
                    dispatch(getSocialMedia({}, (res) => { }))
                }
            }),
        )
    }



    return (
        <div>
            <Loader loading={loaders.isFetching} />
            <div style={{ display: 'flex' }}>
                <div>
                    <p className="headinguser">Social Media</p>
                    <p className="subheadinggraph">Sample data for social media</p>
                </div>
            </div>

            <div>

                {/* <LocalForm model="user" onSubmit={(values) => handleAddSubmit(values)}> */}
                <div className="passTab1">
                    <div className="passDiv">
                        <div class="mb-3">
                            <div
                                style={{

                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    position: 'relative',
                                }}
                            >

                                <label>Facebook
                                    <Tooltip title="This content will be shown to app user while sharing data on facebook">
                                        <IconButton>

                                            <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" /></svg>
                                        </IconButton>
                                    </Tooltip>

                                </label>
                                {/* <div style={{ display: 'flex' }}> */}

                                <Textarea
                                    // model="user.instagram_post_template"
                                    className="form-control description  input-field"
                                    // id="user.instagram_post_template"
                                    type='textarea'
                                    id="user.facebook_post_template"
                                    placeholder="Facebook"
                                    rows={6}
                                    onChange={(e) => setFacebook(e.target.value)}
                                    value={facebook}
                                    defaultValue={socialMediaData?.socialMedia?.facebook_post_template}
                                // maxLength={500}
                                // errors={{
                                //     facebookContent: (val) => !val,
                                //     facebook: (val) => val && val.length < 2,
                                // }}
                                />
                            </div>
                            {/* <Errors
                                    model="user.facebook_post_template"
                                    errors={{
                                        facebookContent,
                                        facebook,
                                    }}
                                /> */}
                        </div>
                    </div>
                </div>
                {/* </FormGroup>
                                </Grid> */}
                <div className="passTab1">
                    <div className="newPassDiv">
                        <div class="mb-3">
                            <div
                                style={{
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    position: 'relative',
                                }}
                            >
                                <label>Twitter
                                    <Tooltip title="This content will be shown to app user while sharing data on twitter">
                                        <IconButton>

                                            <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" /></svg>
                                        </IconButton>
                                    </Tooltip>

                                </label>

                                <Textarea
                                    // model="user.instagram_post_template"
                                    className="form-control description  input-field"
                                    // id="user.instagram_post_template"
                                    type='textarea'
                                    id="user.twitter_post_template"
                                    placeholder="Twitter"
                                    rows={6}
                                    value={twitter}
                                    defaultValue={socialMediaData?.socialMedia?.twitter_post_template}
                                    onChange={(e) => setTwitter(e.target.value)}

                                    maxLength={500}
                                // errors={{
                                //     twitterContent: (val) => !val,
                                //     twitter: (val) => val && val.length < 2,
                                // }}
                                />
                            </div>
                            {/* <Errors
                                    model="user.twitter_post_template"
                                    errors={{
                                        twitterContent,
                                        twitter,
                                    }}
                                /> */}
                        </div>
                    </div>
                </div>
                {/* <div className="confirmPassDiv">
                        <div class="mb-3">
                            <div
                                style={{
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    position: 'relative',
                                }}
                            >
                                <label>Instagram
                                    <Tooltip title="This content will be shown to app user while sharing data on instagram">
                                        <IconButton>

                                            <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" /></svg>
                                        </IconButton>
                                    </Tooltip>
                                </label>


                                <Textarea 
                                    className="form-control description  input-field"
                                    type='textarea'
                                    placeholder="Instagram"
                                    rows={6}
                                    value={instagram}
                                    defaultValue={socialMediaData?.socialMedia?.instagram_post_template}
                                    onChange={(e)=>setInstagram(e.target.value)}

                                   
                                />
                            </div>
                          
                        </div>
                    </div> */}

                <div className="updateBtn">
                    <button onClick={() => handleAddSubmit()} type="submit">Update Content</button>
                </div>
                {/* </LocalForm> */}
            </div>
        </div>
    );

}

export default SocialMedia;